import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  fillRule: "evenodd",
  d: "M11.947 20.998a.596.596 0 0 1-.283-.1l-.036-.027a.602.602 0 0 1-.231-.474v-1.563c0-.333.27-.603.603-.603l.041.002a.603.603 0 0 1 .562.601v1.563a.6.6 0 0 1-.136.38l-.03.034-.031.031A.607.607 0 0 1 12 21l-.053-.002Zm-5.206-4.592a.603.603 0 1 1 .853.853l-1.105 1.105a.6.6 0 0 1-.853 0 .602.602 0 0 1 0-.853l1.105-1.105Zm9.668.003a.6.6 0 0 1 .85 0l1.105 1.105a.6.6 0 1 1-.85.85l-1.105-1.105a.6.6 0 0 1 0-.85ZM5.165 11.397a.603.603 0 0 1 0 1.206H3.603a.603.603 0 0 1 0-1.206h1.562Zm15.234.002a.6.6 0 1 1 0 1.202h-1.563a.6.6 0 1 1 0-1.202H20.4ZM5.636 5.636a.603.603 0 0 1 .853 0l1.105 1.105a.603.603 0 0 1-.853.853L5.636 6.489a.603.603 0 0 1 0-.853Zm11.878 0a.601.601 0 0 1 .85.85L17.259 7.59a.6.6 0 0 1-.85 0 .601.601 0 0 1 0-.85l1.105-1.105ZM12 3l.041.001a.597.597 0 0 1 .08.011l.043.01a.603.603 0 0 1 .439.581v1.563c0 .333-.27.603-.603.603l-.042-.001a.603.603 0 0 1-.561-.602V3.603c0-.291.207-.535.482-.59l.04-.007a.606.606 0 0 1 .08-.006Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  d: "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=SunnyIcon24.js.map